import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ReferralRules from "@/components/referrals/ReferralRules";
import AutomatedMessages from "@/components/referrals/AutomatedMessages";
import { ComingSoonBanner } from "@/components/referrals/ComingSoonBanner";
import { Badge } from "@/components/ui/badge";
const Referrals = () => {
  return <div className="space-y-8">
      <header className="flex items-center gap-3">
        <h1 className="text-2xl font-bold">Indique e Ganhe</h1>
        <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
          Em Breve
        </Badge>
      </header>

      <ComingSoonBanner />

      <div className="relative">
        {/* Overlay para efeito de preview */}
        <div className="absolute inset-0 bg-background/40 backdrop-blur-[0.05px] z-10 rounded-lg" />
        
        <div className="relative opacity-80">
          <Tabs defaultValue="rules">
            <TabsList className="grid w-full max-w-md grid-cols-2">
              <TabsTrigger value="rules" disabled>Regras</TabsTrigger>
              <TabsTrigger value="messages" disabled>Notificações</TabsTrigger>
            </TabsList>
            
            <TabsContent value="rules" className="mt-6">
              <ReferralRules isModuleEnabled={false} previewMode={true} />
            </TabsContent>
            
            <TabsContent value="messages" className="mt-6">
              <AutomatedMessages isModuleEnabled={false} previewMode={true} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>;
};
export default Referrals;